import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController } from '@ionic/angular';

@Component({
  selector: 'app-gsetting',
  templateUrl: './gsetting.page.html',
  styleUrls: ['./gsetting.page.scss'],
})

export class GsettingPage implements OnInit {
  
  ads = false;
  client = false;
  
  constructor(public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

  }

  ngOnInit()
  {
  
  }

  async remove()
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.removeData().subscribe((response:any) => {
    
    this.presentToast("Client data removed successfully.");

     this.nav.navigateRoot('/main'); 

    loading.dismiss();

    });
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }
}
